import { InjectionToken, NgModule } from "@angular/core";
import { ActivatedRouteSnapshot, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { AuthResolverService } from "./services/auth-resolver.service";




/**
 * 
 *
 * Original  
 * 
 * */
const routes: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },

  {
    path: "onlinereputation/renewal",
    loadChildren: () => import("./modules/public-renewal/public-renewal.module").then(m => m.PublicRenewalModule)
  },
  {
    path: "login",
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/login-page/login-page.module").then((module) => module.LoginPageModule)
  },
  {
    path: "logoutsso",
    loadChildren: () => import("./modules/sso/sso.module").then((module) => module.SsoModule)
  },
  {
    path: "errorsso",
    loadChildren: () => import("./modules/error-sso/error-sso.module").then((module) => module.ErrorSsoModule)
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/pages/pages.module").then((module) => module.PagesModule),
    resolve: { user: AuthResolverService }
  },
  {
    path: "maintenance-page",
    canActivate: [AuthGuard],
    loadChildren: () => import("./modules/login-page/login-page.module").then((module) => module.LoginPageModule)
  },
  { path: '**', redirectTo: "" }
];


/**
  * 
  *
  * maintenance router   
  * 
  * */

// const routes: Routes = [
//  { path: "", redirectTo: "maintenance-page", pathMatch: "full" },
//  {
//    path: "-/-",
//    canActivate: [AuthGuard],
//    loadChildren: () => import("./modules/pages/pages.module").then((module) => module.PagesModule)
//  },
//  { path: "", redirectTo: "maintenance-page", pathMatch: "full" },
//  {
//    path: "maintenance-page",
//    loadChildren: () => import("./modules/maintenance-page/maintenance-page.module").then((module) => module.MaintenancePageModule)
//  },
//  { path: "**", redirectTo: "maintenance-page", pathMatch: "full" }
//];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
